<!-- ScorePHQ9.vue -->
<template>
  <v-card>
    <v-card-title class="text-h6 font-weight-bold mb-2">
       {{ $t('scales.mock2.title') }}
    </v-card-title>
    <v-card-text class="px-6 pb-6">
      <div class="mb-8">

        <!--Scores-->
        <div class="mb-3">
          <div class="text-subtitle-1 font-weight-medium mb-2">
            {{ $t('scales.mock2.score') }}: {{ score.total.raw.value }} / {{ score.total.raw.max }}
          </div>
          <v-progress-linear
            :model-value="(score.total.raw.value/score.total.raw.max) * 100"
            color="success"
            height="12"
            rounded
          ></v-progress-linear>
        </div>
        
        <!--Interpretations-->
        <v-alert
          :color="getColor(score.total.raw.color)"
          variant="tonal"
          class="mt-3"
        >
          <template v-slot:prepend>
            <v-icon>mdi-brain</v-icon>
          </template>
          <div>
            <strong>{{ $t('scales.mock2.interpretation') }}:</strong>
            <v-list>
              <v-list-item
                v-for="(item, index) in interpretations"
                :key="index"
                :title="typeof item === 'string' ? item : item.title"
                class="text-wrap"
              ></v-list-item>
            </v-list>
          </div>
        </v-alert>
      </div>

      <!--Individual answers-->
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ $t('scales.mock2.answers') }}
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-list lines="one">
              <v-list-item
                v-for="item, idx in scale.items"
                :key="idx"
                :title="(idx+1) + '. ' + item.text"
                :subtitle="answerText(scale.answers[idx])"
              ></v-list-item>
            </v-list>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      
    </v-card-text>
  </v-card>

</template>

<script>

import CircularProgressComponent from '@/components/common/CircularProgressComponent.vue';
import {getColor} from '@/utils/scales.js';

export default {
  name: 'ScoreMOCK2',
  components: {
    CircularProgressComponent
  },
  data() {
    return {
      scale_id: 'mock2'
    }
  },
  props: {
    scale: {
      type: Object,
      required: true
    },
  },

  methods: {
    getColor,

    /**Get the answer text for an item*/
    answerText(answerValue){
      console.info(typeof answerValue)
      return this.scale.options.find(opt => opt.score == parseInt(answerValue)).name
    },
  },

  computed: {
    score() {
      return this.scale.scores;
    },
    interpretations() {
      return this.scale.interpretations;
    },

    scorePercent(){
      return Math.floor(this.score.total.raw.value / this.score.total.raw.max * 100)
    },    

    severityColor() {
      const colors = {
        'Minimal': 'green',
        'Mild': 'yellow',
        'Moderate': 'orange',
        'Moderately Severe': 'deep-orange',
        'Severe': 'red'
      };
      return colors['Minimal'];
    },

    // interpretationText() {
    //   // Detailed clinical interpretation based on score
    //   const texts = {
    //     'Minimal': 'Minimal or no depression symptoms.',
    //     'Mild': 'Mild depression. Watchful waiting, repeat PHQ-9 at follow-up.',
    //     // ... etc
    //   };
    //   return texts[this.interpretation];
    // }
  }
}
</script>

<style scoped>
.v-list-item :deep(.v-list-item-title) {
  white-space: normal !important;
  overflow-wrap: break-word !important;
}
</style>